<template>
  <div class="contain">
    <div class="hm-radio-group">
      <el-radio-group
        v-model="searchCondition.radSearch"
        size="small"
        @change="switchTab"
      >
        <el-radio-button label="0">待处理</el-radio-button>
        <el-radio-button label="1">已处理</el-radio-button>
        <el-radio-button label="">全部</el-radio-button>
      </el-radio-group>
    </div>
    <div class="form">
      <div
        class="flex "
        :class="searchCondition.radSearch === '0' ? 'flex-between' : 'flex-end'"
      >
        <el-button
          type="primary"
          size="small"
          @click="batchSele"
          v-if="searchCondition.radSearch === '0'"
          >批量处理</el-button
        >
        <div class="flex buttonList">
          <div style="margin-right:10px">
            <el-date-picker
              v-model="searchCondition.createTimeArry"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small"
            >
            </el-date-picker>
          </div>
          <div style="margin-right:10px">
            <el-input
              v-model="searchCondition.tagName"
              size="small"
              placeholder="请输入标签名称"
            ></el-input>
          </div>
          <el-button type="primary" @click="queryRelt" size="small"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table">
        <el-table
          ref="multipleTable"
          style="width: 100%"
          id="table"
          stripe
          border
          size="small"
          :data="tableData"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            align="center"
            :selectable="selectEnable"
            v-if="
              searchCondition.radSearch === '0' ||
                searchCondition.radSearch === ''
            "
          ></el-table-column>
          <el-table-column
            prop="tagName"
            label="标签"
            align="center"
          ></el-table-column>
          <el-table-column prop="name" label="标签值" align="center">
          </el-table-column>

          <el-table-column
            prop="storeName"
            label="所属商户"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="deleteBy"
            label="操作人"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="操作时间"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.createTime | formatDate }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="状态"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.state === '1'">已处理</span>
              <span v-if="scope.row.state === '0'">未处理</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="操作"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="submit(scope.row)"
                >查看详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="uploadedMpTempListTotal"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pageNo"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      orNum: {},
      radSearch: "0",
      value1: "",
      tableData: [],
      name: "",
      pageNo: 1,
      pageSize: 10,
      today: "",
      week: "",
      uploadedMpTempListTotal: 0,
      timeList: [],
      allIds: [],
      searchCondition: {
        radSearch: "0",
        createTimeArry: []
      }
    };
  },
  created() {
    this.searchCondition.createTimeArry = [
      moment(new Date())
        .utc()
        .zone(-8)
        .add(-7, "days")
        .format("YYYY-MM-DD"),
      moment()
        .utc()
        .zone(-8)
        .format("YYYY-MM-DD")
    ];
  },
  mounted() {
    this.get_init();
  },
  filters: {
    formatDate: function(value) {
      let date = new Date(value * 1000);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    }
  },
  methods: {
    selectEnable(row) {
      if (row.state === "1") {
        return false;
      } else {
        return true; // 不禁用
      }
    },
    async get_init() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.pageNo
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.startDate =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.endDate =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;
      Object.assign(params, searchCondition);

      const { result } = await this.$store.dispatch("queryTagDataList", {
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        startDate:
          this.searchCondition.createTimeArry &&
          this.searchCondition.createTimeArry.length > 0
            ? this.searchCondition.createTimeArry[0]
            : null,
        endDate:
          this.searchCondition.createTimeArry &&
          this.searchCondition.createTimeArry.length > 0
            ? this.searchCondition.createTimeArry[1]
            : null,
        state: this.searchCondition.radSearch,
        tagName: this.searchCondition.tagName
      });
      this.tableData = result.records;
      this.uploadedMpTempListTotal = result.totalCount;
    },
    async batchSele() {
      if (this.allIds.length) {
        let id = this.allIds.join(",");
        await this.$store.dispatch("queryTagMake", {
          ids: id,
          source: "detail",
          state: "1"
        });
        this.get_init();
      } else {
        this.$message({
          message: "请先选择！",
          type: "warning"
        });
      }
    },
    change(e) {
      this.timeList = e;
    },
    queryRelt() {
      this.pageNo = 1;
      this.get_init();
    },
    submit(row) {
      this.$confirm("是否删除该信息", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        console.log(row);
      });
    },
    paging(page) {
      this.pageNo = page;
      this.get_init();
    },
    handleSizeChange(size) {
      this.pageNo = 1;
      this.pageSize = size;
      this.get_init();
    },

    handleSelectionChange(val) {
      let ids = val.map(item => item.id);
      this.allIds = ids;
    },
    switchTab() {
      this.$refs.multipleTable.doLayout();
      this.get_init();
    }
  }
};
</script>

<style lang="scss" scoped>
.contain {
  .hm-radio-group {
    padding: 18px 31px;
    background: #ffffff;
  }
  .form {
    padding: 30px;
    background: #ffffff;
    .buttonList {
      justify-content: flex-end;
    }
    .table {
      margin-top: 20px;
    }
    .hm-pagination {
      margin-top: 40px;
    }
  }
}
.deleTent {
  flex-direction: column;
}
</style>
